module.exports = __webpack_public_path__ + "img/cc.ecc0e32.svg";